import { type FC } from 'react';
import { useTranslations } from 'next-intl';

import { Slide } from '@chakra-ui/react';
import { useStore } from '@nanostores/react';

import {
  $multiDecisionStore,
  MakeMultiDecisionActions,
  multiDecisionActions,
} from '@features/merchant';

import { Button, Container, Flex, FooterMenu, Text } from '@shared/ui-kit';

const MultiDecisionPanel: FC = () => {
  const t = useTranslations('General');

  const { isActive, merchantIds } = useStore($multiDecisionStore);

  return (
    <FooterMenu
      opacity={isActive ? '1' : '0'}
      display={isActive ? 'flex' : 'none'}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Slide
        direction="bottom"
        in={isActive}
        unmountOnExit
      >
        <Container>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            pb="5"
          >
            <Text fontWeight="medium">
              {t('selected')}: &nbsp;
              <b>{merchantIds.length}</b>
            </Text>
            <Flex
              alignItems="center"
              columnGap="5"
            >
              <MakeMultiDecisionActions />
              <Button
                data-multiple-select-exclude
                variant="ghost"
                onClick={multiDecisionActions.resetDecisionSelection}
              >
                {t('cancel')}
              </Button>
            </Flex>
          </Flex>
        </Container>
      </Slide>
    </FooterMenu>
  );
};

export default MultiDecisionPanel;
